// @ts-nocheck
import React, { useEffect } from 'react';
import intl from 'react-intl-universal';
import { compose } from '@/utils';
import { ShippingAccountsProvider } from './ShippingAccountsProvider';
import ShippingAccountsDataTable from './ShippingAccountsDataTable';
import withDashboardActions from '@/containers/Dashboard/withDashboardActions';

function ShippingAccountsList({ changePreferencesPageTitle }) {
  useEffect(() => {
    changePreferencesPageTitle(intl.get('shipping_accounts'));
  }, [changePreferencesPageTitle]);

  return (
    <ShippingAccountsProvider>
      <ShippingAccountsDataTable />
    </ShippingAccountsProvider>
  );
}

export default compose(withDashboardActions)(ShippingAccountsList);